import { ReactNode } from "react";
import styled from "@emotion/styled";

import UIcon from "lib/icons/untitled_ui/UIcon";

/**
 * The Stotles insights rail beside a notice: what Stotles knows about the opportunity, one section
 * per insight.
 */
export function NoticeInsightsRail({ children }: { children?: ReactNode }) {
  return (
    <Rail aria-label="Stotles insights">
      <Header>
        <IconTile>
          <UIcon icon="stars2" size={20} color="sysPrimaryDefault" />
        </IconTile>
        <Title>Stotles insights</Title>
      </Header>
      {children}
    </Rail>
  );
}

/**
 * The page or preview content with the rail: edge to edge, as the notice column pads itself and the
 * rail meets the right-hand edge.
 */
export const RailPageContent = styled.div({
  display: "flex",
  flex: 1,
});

// A full-height panel along the right edge, set apart from the notice by its background.
const Rail = styled.aside(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 24,
  width: 400,
  flexShrink: 0,
  boxSizing: "border-box",
  padding: 24,
  // The rail's own tint, so it reads as Stotles' view rather than the notice's.
  background: theme.colors.sysPrimarySubtle,
  borderLeft: `1px solid ${theme.colors.sysBorderDecorative}`,
  "@media screen and (max-width: 880px)": {
    width: "100%",
    borderLeft: "none",
    borderTop: `1px solid ${theme.colors.sysBorderDecorative}`,
  },
}));

const Header = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 8,
});

const IconTile = styled.span(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 32,
  height: 32,
  borderRadius: 4,
  background: theme.colors.sysPrimarySubtleAlt,
}));

const Title = styled.h2(({ theme }) => ({
  margin: 0,
  fontSize: 20,
  fontWeight: 600,
  lineHeight: 1.25,
  color: theme.colors.sysTextDefault,
}));
